<template xmlns:table="http://www.w3.org/1999/html">
  <div class="body">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane name="first" label="基础信息">
        <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">系统编号：</td>
            <td>{{improvedSurvey.billNo}}</td>
            <td class="tableLabel">反馈人：</td>
            <td>{{improvedSurvey.creatorName}}</td>
            <td class="tableLabel">投诉日期：</td>
            <td>{{improvedSurvey.complaintDate}}</td>
          </tr>
          <tr>
            <td class="tableLabel">序列号：</td>
            <td>{{improvedSurvey.serialNo}}</td>
            <td class="tableLabel">出厂编号：</td>
            <td>{{improvedSurvey.factoryNo}}</td>
            <td class="tableLabel">发生阶段：</td>
            <td>
              <span>
                <el-select v-model="improvedSurvey.stage" placeholder="请选择发生阶段">
                  <el-option
                      v-for="item in constant.toSelect(constant.stage)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </span>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">提交时间：</td>
            <td>{{improvedSurvey.submitTime}}</td>
            <td class="tableLabel">客户名称：</td>
            <td>{{improvedSurvey.customerName}}</td>
            <td class="tableLabel">联系方式：</td>
            <td>{{improvedSurvey.contact}}</td>
          </tr>
          <tr>
            <td class="tableLabel">问题描述：</td>
            <td colspan="5">{{improvedSurvey.problemDesc}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane name="second" label="cqe初审">
        <table
            v-if="nodeId==='cqeApprove'"
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">基准：</td>
            <td>
              <el-input v-model="improvedSurvey.standard" placeholder="请输入" type="textarea"/>
            </td>
            <td class="tableLabel">实际：</td>
            <td>
              <el-input v-model="improvedSurvey.practical" placeholder="请输入" type="textarea"/>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">投诉性质：</td>
            <td>
              <span>
                <el-select v-model="improvedSurvey.complaintNature" placeholder="请选择发生阶段">
                  <el-option
                      v-for="item in constant.toSelect(constant.complaintNature)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </span>
            </td>
            <td class="tableLabel">产品大类：</td>
            <td>
              <span>
                <el-select v-model="improvedSurvey.productType" placeholder="请选择发生阶段">
                  <el-option
                      v-for="item in constant.toSelect(constant.productType)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </span>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">调查结果：</td>
            <td>
              <el-input v-model="improvedSurvey.surveyResult" placeholder="请输入" type="textarea"/>
            </td>
            <td class="tableLabel">责任划分：</td>
            <td>
              <div>
                <el-radio-group v-model="improvedSurvey.dutyType">
                  <el-radio :label="1">新时达责任</el-radio>
                  <el-radio :label="2">供应商责任</el-radio>
                  <el-radio :label="3">客户责任</el-radio>
                </el-radio-group>
              </div>
              <div style="margin-top: 1%">
                <el-input
                    v-if="improvedSurvey.dutyType===1"
                    v-model="improvedSurvey.dutyValue"
                    style="width: 60%;"
                    placeholder="请输入"
                    readonly>
                  <el-button slot="append" icon="el-icon-search" style="margin-left: 2%;" @click="$refs.selectDepartment.open()">选择部门</el-button>
                </el-input>
                <el-input
                    v-else-if="improvedSurvey.dutyType===2"
                    v-model="improvedSurvey.dutyValue"
                    style="width: 50%"
                    placeholder="请输入供应商"/>
                <department-select ref="selectDepartment" @select="selectDepartment"/>
              </div>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">是否重复问题：</td>
            <td>
              <span>
                <el-switch
                    v-model="improvedSurvey.isRepeatQuestion"
                    active-color="#13ce66"
                    inactive-color="#9a9999"/>
              </span>
            </td>
            <td class="tableLabel">质量成本：</td>
            <td>
              <el-input-number v-model="improvedSurvey.qualityCost" :precision="2" :step="0.1"/>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">错误分类：</td>
            <td>
              <span>
                <el-select v-model="improvedSurvey.errorClassification" placeholder="请选择发生阶段">
                  <el-option
                      v-for="item in constant.toSelect(constant.errorClassification)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </span>
            </td>
            <td class="tableLabel">投诉等级：</td>
            <td>
              <span>
                <el-select v-model="improvedSurvey.complaintGrade" placeholder="请选择投诉等级">
                  <el-option
                      v-for="item in constant.toSelect(constant.complaintGrade)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </span>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">围堵措施：</td>
            <td>
              <el-input v-model="improvedSurvey.interceptMeasure" placeholder="请输入" type="textarea"/>
            </td>
            <td class="tableLabel">责任人/期限：</td>
            <td>
              <div>
                <el-input v-model="improvedSurvey.interceptHandelName" style="width: 50%" placeholder="请输入"/>
                /
                <el-date-picker
                    v-model="improvedSurvey.allottedTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="date"
                    placeholder="选择日期"/>
              </div>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">是否改进：</td>
            <td>
              <span>
                <el-switch
                    v-model="improvedSurvey.isImproved"
                    active-color="#13ce66"
                    inactive-color="#9a9999"/>
              </span>
            </td>
            <td class="tableLabel">改进负责人：</td>
            <td>
              <el-input v-model="improvedSurvey.improvedHandelName" clearable>
                <el-button slot="append" @click="$refs.improvedHandelSelect.open()">选择</el-button>
              </el-input>
              <user-select ref="improvedHandelSelect" @select="selectImprovedHandel"/>
            </td>
          </tr>
        </table>
        <table
            v-else
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">基准：</td>
            <td>
              {{improvedSurvey.standard}}
            </td>
            <td class="tableLabel">实际：</td>
            <td>
              {{improvedSurvey.practical}}
            </td>
          </tr>
          <tr>
            <td class="tableLabel">投诉性质：</td>
            <td>
              <span>
                <el-select v-model="improvedSurvey.complaintNature" disabled placeholder="请选择投诉性质">
                  <el-option
                      v-for="item in constant.toSelect(constant.complaintNature)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </span>
            </td>
            <td class="tableLabel">产品大类：</td>
            <td>
              <span>
                <el-select v-model="improvedSurvey.productType" disabled placeholder="请选择产品大类">
                  <el-option
                      v-for="item in constant.toSelect(constant.productType)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </span>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">调查结果：</td>
            <td>
              {{improvedSurvey.surveyResult}}
            </td>
            <td class="tableLabel">责任划分：</td>
            <td>
              <div>
                <el-radio-group v-model="improvedSurvey.dutyType" disabled>
                  <el-radio :label="1">新时达责任</el-radio>
                  <el-radio :label="2">供应商责任</el-radio>
                  <el-radio :label="3">客户责任</el-radio>
                </el-radio-group>
              </div>
              <div style="margin-top: 1%">
                <el-input
                    v-if="improvedSurvey.dutyType===1"
                    v-model="improvedSurvey.dutyValue"
                    disabled
                    style="width: 50%"
                    placeholder="请输入责任部门"/>
                <el-input
                    v-else-if="improvedSurvey.dutyType===2"
                    v-model="improvedSurvey.dutyValue"
                    disabled
                    style="width: 50%"
                    placeholder="请输入供应商"/>
              </div>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">是否重复问题：</td>
            <td>
              <span>
                <el-switch
                    v-model="improvedSurvey.isRepeatQuestion"
                    disabled
                    active-color="#13ce66"
                    inactive-color="#9a9999"/>
              </span>
            </td>
            <td class="tableLabel">质量成本：</td>
            <td>
              {{improvedSurvey.qualityCost}}
            </td>
          </tr>
          <tr>
            <td class="tableLabel">错误分类：</td>
            <td>
              <span>
                <el-select v-model="improvedSurvey.errorClassification" placeholder="请选择发生阶段">
                  <el-option
                      v-for="item in constant.toSelect(constant.errorClassification)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </span>
            </td>
            <td class="tableLabel">投诉等级：</td>
            <td>
              <span>
                <el-select v-model="improvedSurvey.complaintGrade" placeholder="请选择投诉等级">
                  <el-option
                      v-for="item in constant.toSelect(constant.complaintGrade)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </span>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">围堵措施：</td>
            <td>
              {{improvedSurvey.interceptMeasure}}
            </td>
            <td class="tableLabel">责任人/期限：</td>
            <td>
              <div>
                <el-input v-model="improvedSurvey.interceptHandelName" disabled style="width: 50%" placeholder="请输入"/>
                /
                <el-date-picker
                    v-model="improvedSurvey.allottedTime"
                    disabled
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="date"
                    placeholder="选择日期"/>
              </div>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">是否改进：</td>
            <td>
              <span>
                <el-switch
                    v-model="improvedSurvey.isImproved"
                    disabled
                    active-color="#13ce66"
                    inactive-color="#9a9999"/>
              </span>
            </td>
            <td class="tableLabel">改进负责人：</td>
            <td>
              <el-input v-model="improvedSurvey.improvedHandelName">
                <el-button slot="append" disabled @click="$refs.improvedHandelSelect.open()">选择</el-button>
              </el-input>
              <user-select ref="improvedHandelSelect" @select="selectImprovedHandel"/>
            </td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane name="third" label="改进措施">
        <table
            v-if="nodeId==='improvedMeasure'"
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">改进描述：</td>
            <td>
              <el-input v-model="improvedSurvey.improvedNote" placeholder="请输入" type="textarea"/>
            </td>
            <td class="tableLabel">改进责任人：</td>
            <td>
              <el-input v-model="improvedSurvey.improvedMeasureName">
                <el-button slot="append" @click="$refs.improvedMeasureSelect.open()">选择</el-button>
              </el-input>
              <user-select ref="improvedMeasureSelect" @select="selectImprovedMeasure"/>
            </td>
          </tr>
        </table>
        <table
            v-else
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">改进描述：</td>
            <td>
              {{improvedSurvey.improvedNote}}
            </td>
            <td class="tableLabel">改进责任人：</td>
            <td>
              {{improvedSurvey.improvedMeasureName}}
            </td>
          </tr>
        </table>
        <div style="margin-top: 5px;margin-bottom:5px;font-weight: bold">
          改进措施
        </div>
        <el-button
            v-if="nodeId==='improvedMeasure'"
            type="primary"
            style="margin-bottom: 10px"
            @click="addImprovedMeasure1">
          新建
        </el-button>
        <el-table :data="improvedSurvey.detailVOS1">
          <el-table-column prop="rootCause" align="center" label="根因">
            <template slot-scope="scope">
              <el-input v-model="scope.row.rootCause"/>
            </template>
          </el-table-column>
          <el-table-column prop="measure" align="center" label="措施">
            <template slot-scope="scope">
              <el-input v-model="scope.row.measure"/>
            </template>
          </el-table-column>
          <el-table-column prop="allottedTime" align="center" label="期限">
            <template slot-scope="scope">
              <el-date-picker
                  v-model="scope.row.allottedTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="选择日期"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120px">
            <template slot-scope="scope">
              <el-button v-if="nodeId==='improvedMeasure'" type="danger" @click="onDelete1(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 5px;margin-bottom:5px;font-weight: bold">
          举一反三
        </div>
        <el-button
            v-if="nodeId==='improvedMeasure'"
            type="primary"
            style="margin-bottom: 10px"
            @click="addImprovedMeasure2">
          新建
        </el-button>
        <el-table :data="improvedSurvey.detailVOS2">
          <el-table-column prop="measure" align="center" label="措施">
            <template slot-scope="scope">
              <el-input v-model="scope.row.measure"/>
            </template>
          </el-table-column>
          <el-table-column prop="dutyName" align="center" label="责任人">
            <template slot-scope="scope">
              <el-input v-model="scope.row.dutyName"/>
            </template>
          </el-table-column>
          <el-table-column prop="allottedTime" align="center" label="期限">
            <template slot-scope="scope">
              <el-date-picker
                  v-model="scope.row.allottedTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="选择日期"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120px">
            <template slot-scope="scope">
              <el-button v-if="nodeId==='improvedMeasure'" type="danger" @click="onDelete2(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane name="fourth" label="改进措施提交">
        <div style="margin-top: 5px;margin-bottom:5px;font-weight: bold">
          改进措施
        </div>
        <el-table :data="improvedSurvey.detailVOS1">
          <el-table-column prop="rootCause" align="center" label="根因"/>
          <el-table-column prop="measure" align="center" label="措施"/>
          <el-table-column prop="allottedTime" align="center" label="期限"/>
          <el-table-column prop="creatorName" align="center" label="上传人"/>
          <el-table-column prop="fileNote" align="center" label="附件说明">
            <template slot-scope="scope">
              <el-input
                  v-model="scope.row.fileNote"
                  :disabled="nodeId!=='improvedMeasureSubmit'"
                  @change="setCreatorName(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120px">
            <template slot-scope="scope">
              <div @click="bigImg(scope.row.filePath)">
                <vm-upload-file
                    v-model="scope.row.filePath"
                    filename.sync=""
                    accept=".jpg,.png"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 1%">
          首单执行时间：
          <el-date-picker
              v-model="improvedSurvey.firstOrderTime"
              :disabled="nodeId!=='improvedMeasureSubmit'"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="date"
              placeholder="选择日期"/>
        </div>
      </el-tab-pane>
      <el-tab-pane name="five" label="改进措施验证">
        <div style="margin-top: 5px;margin-bottom:5px;font-weight: bold">
          改进措施
        </div>
        <el-table :data="improvedSurvey.detailVOS1">
          <el-table-column prop="rootCause" align="center" label="根因"/>
          <el-table-column prop="measure" align="center" label="措施"/>
          <el-table-column prop="allottedTime" align="center" label="期限"/>
          <el-table-column prop="fileNote" align="center" label="附件说明"/>
          <el-table-column prop="identifier" align="center" label="验证人"/>
          <el-table-column prop="verificationResult" align="center" label="是否通过">
            <template slot-scope="scope">
              <el-switch
                  v-model="scope.row.verificationResult"
                  active-color="#13ce66"
                  inactive-color="#9a9999"
                  @change="setIdentifier1(scope.row)"/>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane name="six" label="首单验证">
        <div style="margin-top: 5px;margin-bottom:5px;font-weight: bold">
          改进措施
        </div>
        <el-table :data="improvedSurvey.detailVOS1">
          <el-table-column prop="rootCause" align="center" label="根因"/>
          <el-table-column prop="measure" align="center" label="措施"/>
          <el-table-column prop="allottedTime" align="center" label="期限"/>
          <el-table-column prop="fileNote" align="center" label="附件说明"/>
          <el-table-column prop="identifier2" align="center" label="验证人"/>
          <el-table-column prop="verificationResult2" align="center" label="是否通过">
            <template slot-scope="scope">
              <el-switch
                  v-model="scope.row.verificationResult2"
                  active-color="#13ce66"
                  inactive-color="#9a9999"
                  @change="setIdentifier2(scope.row)"/>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <div>
      <div
          style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
        物料信息
      </div>
      <el-table
          :data="improvedSurvey.materialList">
        <el-table-column prop="materialNo" align="center" label="物料编号"/>
        <el-table-column prop="materialName" align="center" label="物料名称"/>
        <el-table-column prop="quantity" align="center" label="数量"/>
        <el-table-column prop="note" align="center" label="备注"/>
      </el-table>
      <div
          style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
        订单附件
      </div>
      <div
          style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
        <el-upload
            :action="actionUrl"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :on-error="handlerError"
            :file-list="files"
            :show-file-list="false">
          <el-button size="small" type="primary" style="margin: 0 5px 0 0">添加附件</el-button>
        </el-upload>
      </div>
      <el-table
          ref="payData1"
          :data="improvedSurvey.attachments">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="fileName" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                style="width: 50px; height: 50px;margin-right: 10px"
                :src="scope.row.imgUrl"
                :preview-src-list="imgUrls"/>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" align="center" label="附件描述">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.fileName"
                class="tabInput"
                style="width: 400px;margin: 0 auto;text-align: center"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
            <el-button type="danger" @click="oneDelete(scope.row,scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <big-img
        :visible="photoVisible"
        :url="bigImgUrl"
        @closeClick="photoVisible = false"/>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  import VmUploadFile from "@/components/VmUploadFile";
  import BigImg from "@/components/BigImg";
  import auth from "@/util/loginUtil";
  import DepartmentSelect from "@/views/information/Department/DepartmentSelect";

  export default {
    name: "ImprovedSurveyPreview",
    components: {DepartmentSelect, BigImg, UserSelect, HandleDetail, VmUploadFile},
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        constant,
        uploadLoading: false,
        photoVisible: false,
        bigImgUrl: "",
        files: [],
        imgUrls: [],
        fileList: [],
        actionUrl: window.config.basicServerHttpUrl + "file/upload",
        appointmentItemTemplates1: [],
        appointmentItemTemplates2: [],
        nodeId: "",
        activeName: "first",
        improvedSurvey: {
          pkid: "",
          billNo: "",
          creatorName: "",
          improvedHandelName: "",
          improvedMeasureName: "",
          isImproved: "",
          surveyResult: "",
          dutyType: "",
          dutyValue: "",
          standard: "",
          customerId: "",
          customerName: "",
          contact: "",
          submitTime: "", //提交日期
          attachments: [],
          detailVOS1: [],
          detailVOS2: [],
        },
      };
    },
    watch: {
      params: {
        handler() {
          this.toDoApprove();
        },
      },
    },
    mounted() {
      this.getData();
      this.getNodeValue();
    },
    methods: {
      getData() {
        console.log(this.params);
        this.$emit("loading-status", {"loading": true});
        this.$http
          .get("basic", `improvedSurveys/${this.billId}`)
          .then(resp => {
            console.log(resp);
            this.$emit("loading-status", {"loading": false});
            this.improvedSurvey = resp;
            this.improvedSurvey.attachments.forEach(row => {
              if (row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              } else {
                row.imgUrl = "http://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
          });
      },
      bigImg(url) {
        this.photoVisible = true;
        this.bigImgUrl = url;
      },
      setCreatorName(row) {
        row.creatorName = auth.getName();
      },
      setIdentifier1(row) {
        row.identifier = auth.getName();
      },
      setIdentifier2(row) {
        row.identifier2 = auth.getName();
      },
      onDelete1(index) {
        this.improvedSurvey.detailVOS1.splice(index, 1);
      },
      onDelete2(index) {
        this.improvedSurvey.detailVOS2.splice(index, 1);
      },
      addImprovedMeasure1() {
        let params = {
          rootCause: "",
          measure: "",
          allottedTime: "",
          filePath: "",
          type: "1",
        };
        this.improvedSurvey.detailVOS1.push(params);
      },
      addImprovedMeasure2() {
        let params = {
          rootCause: "",
          measure: "",
          allottedTime: "",
          type: "2",
        };
        this.improvedSurvey.detailVOS2.push(params);
      },
      selectImprovedHandel(row) {
        console.log(row);
        this.improvedSurvey.improvedHandelName = row.employeeName;
        this.improvedSurvey.improvedHandelId = row.systemUserID;
      },
      selectImprovedMeasure(row) {
        console.log(row);
        this.improvedSurvey.improvedMeasureName = row.employeeName;
        this.improvedSurvey.improvedMeasureId = row.systemUserID;
        if (row.directorID) {
          //获取主管id
          this.getDirectorID(row.directorID);
        } else {
          this.$message.error("请联系管理员配置部门领导");
        }

        // this.improvedSurvey.directorID = row.directorID;

      },
      getDirectorID(id) {
        this.$http
          .get("basic", `employees/getDirectorID/${id}`)
          .then((res) => {
            this.improvedSurvey.directorID = res;
          });
      },
      //附件表页面删除
      oneDelete(row, index) {
        this.improvedSurvey.attachments.splice(index, 1);
      },
      downLoad(row) {
        if (row.filePath.includes("common")) {
          let url = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
          let a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        } else {
          let a = document.createElement("a");
          a.href = "http://emes.stepelectric.com" + row.filePath;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        }
      },

      handlerError(err, file, fileList) {
        console.log(file);
        console.log(fileList);
        alert(err);
      },
      handleSuccess(response, file, fileList) {
        console.log(file);
        file.path = response;
        this.files = fileList;
        let object = {
          fileName: file.path.originalName,
          filePath: file.path.fullPath,
        };
        this.improvedSurvey.attachments.push(object);
      },
      handleRemove(file, fileList) {
        this.files = fileList;
      },
      pushWeChat() {
        this.$http
          .get("basic", `improvedSurveys/pushWeChat/${this.improvedSurvey.pkid}`)
          .then(() => {
          });
      },
      toDoApprove() {
        console.log(this.params);
        if (this.params.actionType === 0) {
          if (this.nodeId === "cqeApprove") {
            if (this.improvedSurvey.dutyType ===1) {
              if (this.improvedSurvey.dutyValue == null || this.improvedSurvey.dutyValue === "")
                return this.$message.error("责任部门不能为空！！！");
            }
            this.params.applicationVarVOS[0].varValue = this.improvedSurvey.isImproved + "";
            this.params.applicationVarVOS[1].varValue = this.improvedSurvey.improvedHandelId + "";
            this.params.applicationVarVOS[2].varValue = this.improvedSurvey.dutyType + "";
            this.toSave();
          } else if (this.nodeId === "improvedMeasure") {
            this.params.applicationVarVOS[0].varValue = this.improvedSurvey.improvedMeasureId + "";
            this.params.applicationVarVOS[1].varValue = this.improvedSurvey.directorID + "";
            this.toSaveVo();
          } else if (this.nodeId === "improvedMeasureSubmit" || this.nodeId === "improvedMeasureVerify" || this.nodeId === "orderVerify") {
            this.toSaveVo();
          }
        }
        let approveVar = "";
        if (this.params.actionType === 0) {
          let list = this.params.applicationVarVOS;
          if (list.length > 0) {
            for (let i = 0; i < list.length; i++) {
              if (i === list.length - 1) {
                approveVar += list[i].varName + "#" + list[i].varValue;
              } else {
                approveVar += list[i].varName + "#" + list[i].varValue + "|";
              }
            }
          }
        }
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          transferTo: this.params.transferTo,
          approveVar: approveVar,
          billParam: "",
        };
        this.doApprove(params);
      },
      toSave() {
        this.$http
          .put("basic", "improvedSurveys", this.improvedSurvey)
          .then(() => {
          });
      },
      toSaveVo() {
        this.$http
          .put("basic", "improvedSurveys/saveVo", this.improvedSurvey)
          .then(() => {
          });
      },
      sentWx(pkid) {
        this.$http
          .get("basic", `improvedSurveys/sentWx/${pkid}/28`)
          .then(() => {
          });
      },
      doApprove(params) {
        this.$emit("loading-status", {"loading": true});
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            if (this.params.actionType === 0 && this.nodeId === "cqeApprove") {
              this.pushWeChat();
            }
            this.sentWx(params.billId);
            this.$emit("loading-status", {"loading": false});
            this.$message.success("操作成功");
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/workFlow/ImprovedSurvey",
            });
          }).catch(() => {
            this.$emit("loading-status", {"loading": false});
          });
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.improvedSurvey.attachments.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      updateStatus() {
        this.$http
          .get("basic", `improvedSurveys/back/${this.improvedSurvey.pkid}`)
          .then(() => {
            this.$message.success("退回到提交人成功！！！");
          });
      },
      selectDepartment(row) {
        this.improvedSurvey.dutyValue = row.departmentName;
      },
      getNodeValue() {
        let params = {
          "billType": this.billType,
          "billId": this.billId,
          "sequId": this.sequId,
        };
        this.$http
          .get("basic", "applications/approve", params)
          .then(resp => {
            this.nodeId = resp.nodeId;
            console.log(this.nodeId);
            if (this.nodeId === "cqeApprove") {
              this.activeName = "second";
            } else if (this.nodeId === "improvedMeasure" || this.nodeId === "improvedMeasure_fs" || this.nodeId === "cqeApprove_fs") {
              this.activeName = "third";
            } else if (this.nodeId === "improvedMeasureSubmit") {
              this.activeName = "fourth";
            } else if (this.nodeId === "improvedMeasureVerify") {
              this.activeName = "five";
            } else if (this.nodeId.includes("orderVerify")) {
              this.activeName = "six";
            } else {
              this.activeName = "first";
            }
          });
      },
    },
  };
</script>
<style lang="scss">
table.ProjectOrderTable {
  font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

table.ProjectOrderTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}

table.ProjectOrderTable td {
  padding: 8px;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}

.tableLabel {
  width: 10%;
  text-align: right;
  background-color: #D1E6F5;
}
</style>
